module.exports = __webpack_public_path__ + "static/media/circle.7ea90997.svg";